import { Terps } from "custom-types/Strain";
import { moveObjToSortedArray } from "utils/moveObjToSortedArray";

export const extractTopTerp = (terps: Terps) => {
  return moveObjToSortedArray(terps, "score").filter(
    (terp) => terp.score > 0,
  )[0];
};
